import {Component, Input, OnInit} from '@angular/core';
import {AppContext} from '../../app-context';
import {cloneObject} from "../utils";
import {AppCommonUtils} from "../app-common-utils";
import {View} from '../view';
import {UpdateUserInfo} from "@flowmaps-com/flowmaps-typescriptmodels";

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.css']
})
export class LanguageSelectorComponent extends View implements OnInit {
  appContext = AppContext;
  @Input() language;

  ngOnInit(): void {
    this.setLanguage(this.language || AppCommonUtils.getPreferredLanguage());
  }

  changeLanguage(language: string) {
    this.setLanguage(language);
    if (AppContext.userProfile) {
      // AppContext.userProfile.details.language = language;
      this.updateInfo();
    }
    location.reload();
  }

  setLanguage(language: string) {
    this.language = language;
    if (AppContext.userProfile) {
      // AppContext.userProfile.details.language = language;
    }
    AppCommonUtils.initialiseLanguage(language);
    // changeLanguage already reloads the document. The document-level bootstrap
    // applies its stored language once; multiple menu instances must not retrigger it.
  }

  updateInfo() {
    const command: UpdateUserInfo = {userId: AppContext.userProfile.userId, info: cloneObject(AppContext.userProfile.info)};
    this.sendCommand("com.flowmaps.api.user.UpdateUserInfo", command, () => {
      AppContext.userProfile.info = cloneObject(command.info);
    });
  }
}
